import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'

const ListItem = ({
  heading,
  headerStyle,
  items,
  counts,
  icons,
  className,
  itemClassName,
  activeItem,
  setActiveItem,
  showIcon,
  color,
  layout
}) => {
  if (layout === 'card') {
    return (
      <div className={`${styles.listItemWrapper} ${className}`}>
        <div className={styles.cardItems}>
          {items.map((i, idx) => (
            <div
              key={idx}
              className={`${styles.cardItem} ${activeItem === i ? styles.active : ''} ${itemClassName}`}
              onClick={() => setActiveItem(i)}>
              {showIcon && icons && <Icon name={icons[idx]} size='large24' />}
              <span>{i}</span>
              <div className={`${styles.backgroundImage} ${styles[color]}`}>
                <Icon name='arrow-right' size='large24' />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
  return (
    <div className={`${styles.listItemWrapper} ${className}`}>
      {heading && <h1 className={`${styles.heading} ${headerStyle}`}>{heading}</h1>}

      <ul className={styles.items}>
        {items.map((i, idx) => (
          <li
            key={idx}
            className={`${activeItem === i ? styles.active : ''} ${itemClassName}`}
            onClick={() => setActiveItem(i)}>
            {i} {showIcon && <Icon name='arrow-right' size='medium' />}{' '}
            {counts?.length > 0 && counts[idx] > 0 && <span>({counts[idx]})</span>}
          </li>
        ))}
      </ul>
    </div>
  )
}

ListItem.propTypes = {
  items: PropTypes.array.isRequired,
  counts: PropTypes.array,
  icons: PropTypes.array,
  heading: PropTypes.string,
  className: PropTypes.string,
  activeItem: PropTypes.string,
  showIcon: PropTypes.bool,
  setActiveItem: PropTypes.func,
  renderIcon: PropTypes.func,
  layout: PropTypes.string,
  color: PropTypes.string
}

ListItem.defaultProps = {
  heading: '',
  className: '',
  activeItem: '',
  showIcon: false,
  layout: 'list',
  color: 'green'
}

export default ListItem
